import { render, staticRenderFns } from "./cmpItem2.vue?vue&type=template&id=3141fc8b&scoped=true"
import script from "./cmpItem2.vue?vue&type=script&lang=js"
export * from "./cmpItem2.vue?vue&type=script&lang=js"
import style0 from "./cmpItem2.vue?vue&type=style&index=0&id=3141fc8b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3141fc8b",
  null
  
)

export default component.exports